function handleMouseover(item, arr) {
  arr.forEach((elem) => {
    elem.classList.remove('hidden');

    if (elem !== item) elem.classList.add('hidden');
  });
}

function handleMouseout(arr) {
  arr.forEach((elem) => {
    elem.classList.remove('hidden');
  });
}

export default function handleHover(className, classNameExclude = null) {
  const navigation = document.querySelector(className);
  if (!navigation) return;

  let items = [];
  if (!classNameExclude) {
    items = navigation.querySelectorAll('.menu-item');
  } else {
    items = navigation.querySelectorAll(`.menu-item:not(${classNameExclude})`);
  }
  if (!items || !items.length) return;

  [...items].forEach((item) => {
    item.addEventListener('mouseover', () => handleMouseover(item, [...items]));
    item.addEventListener('mouseout', () => handleMouseout([...items]));

    const link = item.querySelector('a');
    if (link) {
      link.addEventListener('focusin', () => handleMouseover(item, [...items]));
      link.addEventListener('focusout', () => handleMouseout([...items]));
    }
  });
}
